<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="_modal__content px-10 py-6 flex flex-col items-center justify-center"
		>
			<div>
				<img
					alt="Luca Education"
					src="@/assets/images/illustrations/recommend.png"
					title="Luca Education"
				/>
			</div>
			<div
				class="_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
			>
				Gợi ý {{ $filters.terminology('plan') }} cho học sinh mới nhập học hoàn toàn
				miễn phí!
			</div>
			<div class="text-center text-neutral-500 mt-2">
				Bạn có muốn áp dụng cho kế hoạch này?
			</div>
			<ul class="text-neutral-700 mt-6 list">
				<li>
					Tự động xây dựng kế hoạch từ thư viện tham khảo chuẩn của
					Luca
				</li>
				<li>Gợi ý mục tiêu can thiệp theo từng lĩnh vực</li>
				<li>
					Linh hoạt thiết lập số lượng mục tiêu theo Mức độ ưu tiên và
					Tháng tuổi
				</li>
			</ul>
		</div>
		<div
			class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				type="button"
				@click="$emit('submit')"
			>
				Tự thiết lập thủ công
			</button>
			<button
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="$emit('useRecommend')"
			>
				Sử dụng gợi ý
			</button>
		</div>
	</div>
</template>


<style scoped>
.list {
	list-style-type: disc !important;
	margin-left: 24px;
}
</style>